<!--
   面包屑
	Created by 吴乔 on 2018/10/24.
-->
<template>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item,index) in pathList" :key="index" :to="{ path: item.path }" :class="{'color26 fontB' : !item.path,'color33':item.path}">{{item.title}}</el-breadcrumb-item>
      </el-breadcrumb>
      <span class="back aHover" v-show="isBack" @click="goBack">
        <i class="iconfont iconfanhui size16"></i>返回
      </span>
    </div>
</template>

<script type="es6">
  /*
  * 入参：pathList
  * 入参格式示例：[{"title":"所有产品","path":"/product/list"},{"title":"新建产品","path":""}]
  * 入参参数说明：title -> 面包屑显示文字
  *              path -> 面包屑点击路由(指定了path，即可点击切换，文字颜色#289EFC
  * */
    export default {
        // props:["pathList"],
      props: {
        pathList: {
          type: Array,
          default: () => ['']
        },
        isBack: {
          type: Boolean,
          default: false
        }
      },
      data() {
          return {}
      },
      mounted(){

      },
      methods: {
        goBack() {
          this.$router.go(-1)
        }
      },
      beforeRouteLeave (to, from, next){
        to.meta.keepAlive = true;
        next();
      }
    }
</script>
<style scoped>
  .breadcrumb{
    height: 45px;
    line-height: 45px;
    display: flex;
    align-items: center;
  }
  .breadcrumb /deep/ .el-breadcrumb__inner{
    font-weight: 400;
  }
  .breadcrumb /deep/ .fontB .el-breadcrumb__inner{
    color: #666;
  }
  .breadcrumb /deep/ .el-breadcrumb {
    font-size: 12px;
    line-height: 1;
  }
  .back {
    margin-left: auto;
    color:#666;
    cursor: pointer;
  }

  .back i {
    margin-right: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonModel/breadcrumb.vue